import axiosInstance from '../../services/api';

export class ElasticsearchService {
  /**
   * Universal search for any ES document and field.
   *
   * @param {Object} params - Search parameters
   * @param {string} params.document - ES document name
   * @param {string} params.field - ES field path
   * @param {string} [params.q] - Search query
   * @param {number} [params.page] - Page number
   * @param {number} [params.size] - Page size
   * @param {string} [params.sort] - Sort by 'count' or 'key'
   * @param {string} [params.order] - Order 'asc' or 'desc'
   * @param {Object} [options] - Optional request controls
   * @param {AbortSignal} [options.signal] - Forwarded to axios so callers
   *   (e.g. React Query) can cancel in-flight requests when inputs change.
   *   Optional and defaults to undefined — existing callers stay unchanged.
   */
  static async search(params, { signal } = {}) {

    const { data } = await axiosInstance.get('/api/search/elasticsearch/', {
      params,
      signal,
    });

    return data;
  }
}

export const elasticsearchKeys = {
  search: (params) => ['elasticsearch', 'search', params],
};
